/**
 * Remote (internet / Cloudflare tunnel) library access UI.
 * When false, tunnel/daemon controls are hidden; LAN and local library remain.
 * Flip to true to restore remote-access Settings and MiniPlayer tunnel status.
 */
export const REMOTE_ACCESS_ENABLED = false;
